import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const DISCIPLINES_REQUEST = 'FETCH_DISCIPLINES_REQUEST';
export const DISCIPLINES_FAILURE = 'FETCH_DISCIPLINES_FAILURE';
export const DISCIPLINES_SUCCESS = 'FETCH_DISCIPLINES_SUCCESS';

export const fetchDisciplines = () => {
    return function(dispatch) {
        dispatch(fetchDisciplinesRequest());
        return axios(apiRequestOptions(apiPath.DISCIPLINES.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchDisciplinesSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchDisciplinesFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchDisciplinesRequest = () => {
    return {
        type: DISCIPLINES_REQUEST,
    }
};

const fetchDisciplinesFailure = (error) => {
    return {
        type: DISCIPLINES_FAILURE,
        error,
    }
};

const fetchDisciplinesSuccess = (data) => {
    return {
        type: DISCIPLINES_SUCCESS,
        data,
    }
};
